import { mdiAlphabeticalVariant, mdiNumeric1, mdiRomanNumeral1, mdiSurroundSound21 } from '@mdi/js';

export const orderedListConfig = {
  a: { title: 'Letters', icon: mdiAlphabeticalVariant },
  i: { title: 'Roman literals', icon: mdiRomanNumeral1 },
  '1': { title: 'Numbers', icon: mdiNumeric1 },
  '1.1': { title: 'Decimal', icon: mdiSurroundSound21 },
};

// Hex values are the project's `error-700` / `success-700` / `primary-700` tokens (also Tailwind's
// `red-700` / `green-700` / `blue-700`). Stored as hex because the value is persisted inline on the
// Tiptap span and rendered by the PDF Lambda, which doesn't share the SPA's Tailwind theme.
export const TEXT_COLOR_PALETTE = {
  red: '#b91c1c',
  green: '#15803d',
  blue: '#1d4ed8',
} as const;

export type TextColorName = keyof typeof TEXT_COLOR_PALETTE;
export type TextColorValue = (typeof TEXT_COLOR_PALETTE)[TextColorName];

export const SUPPORTED_TEXT_COLORS: readonly string[] = Object.values(TEXT_COLOR_PALETTE);

export const isSupportedTextColor = (value: string | null | undefined): value is TextColorValue =>
  typeof value === 'string' && SUPPORTED_TEXT_COLORS.includes(value.toLowerCase());
